<template>
  <b-modal
    v-model="showModal"
    centered
    size="lg"
    header-class="custom-modal-header"
    hide-footer
  >
    <template #modal-header>
      <div class="d-flex justify-content-between align-items-center w-100">
        <p>ASSIGN TO</p>
        <div class="d-flex justify-content-center align-items-center">
          <!-- <b-form-checkbox v-model="form.isAlwayAutoAssign"
            >Always Auto Assign to this Agent</b-form-checkbox
          > -->
          <button
            type="button"
            aria-label="Close"
            class="btn p-0"
            @click="hide"
          >
            <font-awesome-icon icon="times" title="Delete" />
          </button>
        </div>
      </div>
    </template>
    <div class="mb-2">
      <b-input-group class="mr-3">
        <b-form-input
          v-model="filter.search"
          placeholder="Search Staff ID / Name / Email / Employee ID"
          @keydown.enter="handleSearch"
        />
        <b-input-group-append>
          <b-button @click="search" class="search-button">
            <font-awesome-icon icon="search" />
          </b-button>
        </b-input-group-append>
      </b-input-group>
    </div>
    <b-table
      responsive
      striped
      hover
      class="table-list"
      :items="items"
      :fields="fields"
      :busy="isBusy"
      show-empty
      :empty-text="$t('noData')"
    >
      <template v-slot:table-busy>
        <div class="text-center text-black my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong class="ml-2">Loading...</strong>
        </div>
      </template>
      <template v-slot:cell(id)="data">
        <div class="d-flex justify-content-center">
          <button
            type="button"
            @click="onSubmit(data.item)"
            :disabled="
              isDisabled ||
              userGUID == data.item.userGUID
            "
            class="btn btn-main"
          >
            Select
          </button>
        </div>
      </template>
      <template v-slot:cell(username)="data">
        <div class="d-flex flex-column align-items-start">
          <span>{{ data.item.firstname }} {{ data.item.lastname }}</span>
          <span class="text-warning-message">{{ data.item.userGUID }} </span>
          <span class="text-warning-message">{{ data.item.username }} </span>
        </div>
      </template>
      <template v-slot:cell(team)="data">
        <div class="d-flex justify-content-center" v-if="data.item.team.length">
          <span v-for="(name, index) in data.item.team" v-bind:key="index">
            {{ name
            }}<span class="mx-1" v-if="index + 1 != data.item.team.length"
              >,</span
            >
          </span>
        </div>
        <span v-else>-</span>
      </template>
    </b-table>
    <b-row class="no-gutters px-3 px-sm-0">
      <b-col class="form-inline justify-content-end justify-content-sm-end">
        <div class="d-sm-flex">
          <b-pagination
            v-model="filter.pageNo"
            :total-rows="rows"
            :per-page="filter.perPage"
            class="m-md-0"
            @change="pagination"
            align="center"
          ></b-pagination>
        </div>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import InputText from "@/components/inputs/InputText";
import { mapGetters } from "vuex";

export default {
  name: "ModalForm",
  components: {
    InputText,
  },
  props: {
    data: {
      required: false,
      type: Array,
    },
    userGUID: {
      required: false,
      type: String,
    },
  },
  data: function () {
    return {
      showModal: false,
      isDisabled: false,
      rows: 0,
      filter: {
        search: "",
        pageNo: 1,
        perPage: 5,
      },
      form: {
        assignFromGUIDs: [],
        assignToGUID: "",
        // isAlwayAutoAssign: false,
      },
      fields: [
        {
          key: "id",
          label: "",
          class: "w-action",
        },
        {
          key: "username",
          label: "Name / Staff ID / Email",
          class: "w-100px",
          tdClass: "text-center",
        },
        {
          key: "team",
          label: "Team",
          class: "w-100px",
          tdClass: "text-center",
        },
      ],
      isBusy: false,
      items: [],
    };
  },
  async mounted() {
    await this.getList();
  },
  computed: {
    ...mapGetters(["getUserDetail"])
  },
  methods: {
    show() {
      this.showModal = true;
    },
    hide() {
      this.showModal = false;
    },
    onSubmit: async function (item) {
      this.isDisabled = true;
      this.form.assignFromGUIDs = this.data;
      this.form.assignToGUID = item.userGUID;
      await this.axios
        .post(
          `${this.$baseUrl}/customer/customer-fix-agent-change-agent`,
          this.form
        )
        .then((data) => {
          if (data.result == 1) {
            this.$store.commit("UPDATE_GLOBAL_ALERT", {
              isShow: true,
              msg: data.message,
            });
            this.$emit("reloadData");
            this.hide();
          } else
            this.$store.commit("UPDATE_GLOBAL_ALERT_ERROR", {
              isShow: true,
              msg: data.detail,
            });
        })
        .catch((err) => {
          this.isDisabled = false;
          this.$store.commit("UPDATE_GLOBAL_ALERT_ERROR", {
            isShow: true,
            msg: err.message,
          });
        });

      setTimeout(() => {
        this.isDisabled = false;
      }, 2000);
    },
    getList: async function () {
      this.isBusy = true;
      await this.axios
        .post(`${this.$baseUrl}/user/List`, this.filter)
        .then((data) => {
          if (data.result == 1) {
            this.items = data.detail.userList;
            this.rows = data.detail.count;
            this.isBusy = false;
          }
        });
    },
    handleSearch(e) {
      if (e.keyCode === 13) {
        this.filter.pageNo = 1;
        this.getList();
      }
    },
    search() {
      this.filter.pageNo = 1;
      this.getList();
    },
    pagination(Page) {
      this.filter.pageNo = Page;
      this.getList();
    },
  },
};
</script>

<style lang="scss" scoped>
.btn-main {
  min-width: 0 !important;
}

.text-warning-message {
  color: #b0adadff;
  font-size: 14px;
}
</style>
